// Reusable error message component

import React from 'react';
import './ErrorMessage.css';

const ErrorMessage = ({ message, onRetry }) => {
    return (
        <div className="error-message-container">
            <div className="error-icon">⚠️</div>
            <p className="error-text">{message}</p>
            {onRetry && (
                <button onClick={onRetry} className="retry-button">
                    Try Again
                </button>
            )}
        </div>
    );
};

export default ErrorMessage;
